"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _theme = require("@veneer/theme");
var _size = _interopRequireDefault(require("polished/lib/shorthands/size"));
var _high_contrast_media_query = _interopRequireDefault(require("../utils/high_contrast_media_query"));
var _use_color = _interopRequireDefault(require("../utils/use_color"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function normalizeQuietArea(value) {
  if (!value || value < 0) return undefined;
  if (value > 100) return 100;
  return value;
}
var useStyles = function useStyles(_ref) {
  var color = _ref.color,
    disabled = _ref.disabled,
    flippable = _ref.flippable,
    isRTL = _ref.isRTL,
    isSvg = _ref.isSvg,
    quietArea = _ref.quietArea,
    size = _ref.size;
  var theme = (0, _theme.useTheme)();
  var imageColor = (0, _use_color.default)(color !== null && color !== void 0 ? color : theme.color.foreground.default);
  return _react.default.useMemo(function () {
    var quietAreaSize = quietArea && typeof size === 'number' ? typeof quietArea === 'function' ? quietArea(size) : Math.ceil(quietArea * size / 100) : undefined;
    return _objectSpread(_objectSpread(_objectSpread({
      boxSizing: 'border-box',
      cursor: disabled ? 'default' : undefined,
      display: 'inline-block',
      filter: disabled ? 'grayscale(1)' : undefined,
      padding: normalizeQuietArea(quietAreaSize),
      userSelect: 'none',
      width: !isSvg ? size : undefined
    }, (0, _high_contrast_media_query.default)(theme)), isSvg && _objectSpread({
      color: imageColor,
      fill: 'currentColor'
    }, (0, _size.default)(size))), isRTL && flippable && {
      transform: 'scaleX(-1)'
    });
  }, [disabled, flippable, imageColor, isRTL, isSvg, quietArea, size, theme]);
};
var _default = exports.default = useStyles;